<template>
  <div class="cloud-disk-sms-page">
    <div class="search-bar">
      <el-input
        v-model.trim="query.keyword"
        clearable
        size="small"
        placeholder="手机号/姓名/学生ID/订单号"
        style="width: 280px"
        @keyup.enter.native="search"
      />
      <el-select
        v-model="query.smsSent"
        clearable
        size="small"
        placeholder="短信下发状态"
        style="width: 150px"
      >
        <el-option label="已发送" :value="true" />
        <el-option label="未发送" :value="false" />
      </el-select>
      <el-button
        type="primary"
        size="small"
        icon="el-icon-search"
        @click="search"
        >查询</el-button
      >
      <el-button
        type="success"
        size="small"
        :disabled="!selection.length"
        @click="openBatchDialog"
      >
        群发短信（{{ selection.length }}）
      </el-button>
    </div>

    <el-table
      v-loading="loading"
      :data="rows"
      border
      stripe
      height="100%"
      @selection-change="selection = $event"
    >
      <el-table-column
        type="selection"
        width="48"
        :selectable="rowSelectable"
      />
      <el-table-column prop="orderNo" label="订单号" min-width="170" />
      <el-table-column prop="studentName" label="姓名" min-width="100" />
      <el-table-column
        prop="studentId"
        label="学生ID"
        min-width="180"
        show-overflow-tooltip
      />
      <el-table-column prop="msisdn" label="云盘手机号" width="125" />
      <el-table-column
        prop="userId"
        label="云盘用户ID"
        min-width="140"
        show-overflow-tooltip
      />
      <el-table-column
        v-if="failureOnly"
        prop="failureReason"
        label="失败原因"
        min-width="240"
        show-overflow-tooltip
      />
      <el-table-column :label="smsLabel" width="110" align="center">
        <template slot-scope="scope">
          <el-tag :type="isSent(scope.row) ? 'success' : 'info'" size="small">
            {{ isSent(scope.row) ? "已发送" : "未发送" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column :label="smsLabel + '时间'" width="165">
        <template slot-scope="scope">{{
          formatTime(sentTime(scope.row))
        }}</template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="150" align="center">
        <template slot-scope="scope">
          <el-button
            v-if="!isSent(scope.row)"
            type="text"
            :disabled="!rowSelectable(scope.row)"
            @click="openSingleDialog(scope.row)"
            >{{ actionText }}</el-button
          >
          <el-button v-else type="text" @click="openSingleDialog(scope.row)"
            >重新下发</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination
        :current-page="query.page"
        :page-size="query.size"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @current-change="changePage"
        @size-change="changeSize"
      />
    </div>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="560px"
      :close-on-click-modal="false"
    >
      <el-alert :title="sendTip" type="warning" :closable="false" show-icon />
      <el-input
        v-model.trim="messageContent"
        type="textarea"
        :rows="5"
        maxlength="500"
        show-word-limit
        style="margin-top: 16px"
        placeholder="请输入已审核的短信内容"
      />
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="sending" @click="confirmSend"
          >确认下发</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  queryCloudDiskSmsUsers,
  queryCloudDiskSmsFailureUsers,
  sendCloudDiskSms,
  previewCloudDiskSmsBatch,
  sendCloudDiskSmsBatch,
} from "@/api/yunpan";

export default {
  name: "CloudDiskSmsUserList",
  props: { failureOnly: { type: Boolean, default: false } },
  data() {
    return {
      loading: false,
      sending: false,
      rows: [],
      selection: [],
      total: 0,
      query: { keyword: "", smsSent: null, page: 1, size: 20 },
      dialogVisible: false,
      singleRow: null,
      messageContent: "",
    };
  },
  computed: {
    businessResult() {
      return this.failureOnly ? "FAILURE" : "SUCCESS";
    },
    smsLabel() {
      return this.failureOnly ? "失败提醒" : "开通短信";
    },
    actionText() {
      return this.failureOnly ? "下发失败提醒" : "下发开通短信";
    },
    dialogTitle() {
      return this.singleRow ? this.actionText : `批量${this.actionText}`;
    },
    sendTip() {
      const count = this.singleRow ? 1 : this.selection.length;
      return `本次将向 ${count} 位用户发送短信，请确认内容已经审核。`;
    },
  },
  created() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        const api = this.failureOnly
          ? queryCloudDiskSmsFailureUsers
          : queryCloudDiskSmsUsers;
        const res = await api(this.query);
        this.rows = res.data.content || [];
        this.total = res.data.totalElements || 0;
      } finally {
        this.loading = false;
      }
    },
    search() {
      this.query.page = 1;
      this.load();
    },
    changePage(page) {
      this.query.page = page;
      this.load();
    },
    changeSize(size) {
      this.query.size = size;
      this.query.page = 1;
      this.load();
    },
    isSent(row) {
      return this.failureOnly ? row.failureSmsSent : row.successSmsSent;
    },
    sentTime(row) {
      return this.failureOnly ? row.failureSmsSentTime : row.successSmsSentTime;
    },
    rowSelectable(row) {
      return !!row.orderId && row.mobileValid;
    },
    formatTime(value) {
      return value ? String(value).replace("T", " ") : "-";
    },
    defaultContent() {
      return this.failureOnly
        ? "您的云盘业务暂未开通成功，请稍后重试或联系客服处理。"
        : "您的云盘业务已成功开通，请登录移动云盘查看。";
    },
    openSingleDialog(row) {
      this.singleRow = row;
      this.messageContent = this.defaultContent();
      this.dialogVisible = true;
    },
    openBatchDialog() {
      this.singleRow = null;
      this.messageContent = this.defaultContent();
      this.dialogVisible = true;
    },
    async confirmSend() {
      if (!this.messageContent) return this.$message.warning("请输入短信内容");
      this.sending = true;
      try {
        if (this.singleRow) {
          await sendCloudDiskSms({
            orderId: this.singleRow.orderId,
            businessResult: this.businessResult,
            content: this.messageContent,
          });
          this.$message.success("短信下发处理完成");
        } else {
          const orderIds = this.selection.map((item) => item.orderId);
          const idempotencyKey = `WEB-${Date.now()}-${Math.random()
            .toString(36)
            .slice(2, 10)}`;
          const data = {
            orderIds,
            businessResult: this.businessResult,
            content: this.messageContent,
            idempotencyKey,
          };
          const preview = await previewCloudDiskSmsBatch(data);
          if (preview.data.failureCount > 0) {
            await this.$confirm(
              `预检发现 ${preview.data.failureCount} 条无效数据，是否继续发送其余 ${preview.data.successCount} 条？`,
              "群发预检",
              { type: "warning" }
            );
          }
          const res = await sendCloudDiskSmsBatch(data);
          this.$message.success(`群发任务已提交，批次号：${res.data.batchNo}`);
        }
        this.dialogVisible = false;
        this.load();
      } finally {
        this.sending = false;
      }
    },
  },
};
</script>

<style scoped>
.cloud-disk-sms-page {
  height: calc(100vh - 180px);
  display: flex;
  flex-direction: column;
}
.search-bar {
  display: flex;
  gap: 10px;
  margin-bottom: 14px;
  align-items: center;
}
.pagination {
  display: flex;
  justify-content: flex-end;
  padding-top: 14px;
}
</style>
